// extracted by mini-css-extract-plugin
export var legendIndicator = "_8n-1";
export var legendRight = "_8n-0";